export enum FlatType {
  PISO = 'PISO',
  CASA = 'CASA',
  CASA_RURAL = 'CASA_RURAL',
  'BOX/PLAZA_DE_GARAJE' = 'BOX/PLAZA_DE_GARAJE',
  TERRENOS = 'TERRENOS',
  COMERCIAL = 'COMERCIAL',
  ÁTICO = 'ÁTICO',
  EDIFICIO = 'EDIFICIO',
  TRASTERO = 'TRASTERO',
}

export const flatTypeDict = {
  [FlatType.PISO]: {
    singular: 'piso',
    plural: 'pisos',
  },
  [FlatType.CASA]: {
    singular: 'casa',
    plural: 'casas',
  },
  [FlatType.CASA_RURAL]: {
    singular: 'casa-rural',
    plural: 'casas-rurales',
  },
  [FlatType['BOX/PLAZA_DE_GARAJE']]: {
    singular: 'garaje',
    plural: 'garajes',
  },
  [FlatType.TERRENOS]: {
    singular: 'terreno',
    plural: 'terrenos',
  },
  [FlatType.COMERCIAL]: {
    singular: 'local-comercial',
    plural: 'locales-comerciales',
  },
  [FlatType.ÁTICO]: {
    singular: 'atico',
    plural: 'aticos',
  },
  [FlatType.EDIFICIO]: {
    singular: 'edificio',
    plural: 'edificios',
  },
  [FlatType.TRASTERO]: {
    singular: 'trastero',
    plural: 'trasteros',
  },
};
